module.exports = __webpack_public_path__ + "img/horizontal_4_3_r_5012.eb26b760.png";